import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue, FctValue24, FctValue160 } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { SWAP_ROUTER_ADDRESSES } from '../helpers/constants';
export var ExactInputSingle = createPlugin({
    protocol: 'UNISWAP_V3',
    type: 'ACTION',
    method: 'exactInputSingle',
    name: 'snipper',
    supportedContracts: SWAP_ROUTER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    params_tuple: {
                        tokenIn: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }), isPreview: true }),
                        tokenOut: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }), isPreview: true }),
                        fee: new FctValue24({ options: [{ value: '500', name: '0.05%' }, { value: '3000', name: '0.3%' }, { value: '10000', name: '1%' }], isPreview: true }),
                        recipient: new FctAddress({ isPreview: true }),
                        deadline: new FctTimestamp({ isPreview: true }),
                        amountIn: new FctValue({ destination: 'wei_amount', isPreview: true }),
                        amountOutMinimum: new FctValue({ destination: 'wei_amount', isPreview: true }),
                        sqrtPriceLimitX96: new FctValue160({ isPreview: true }),
                    },
                },
            },
            output: {
                amountOut: new FctValue({}),
            },
        });
    },
    initParams: {
        methodParams: {
            params_tuple: {
                fee: '3000',
                deadline: { type: 'global', id: 'blockTimestamp' },
                amountOutMinimum: '0',
                sqrtPriceLimitX96: '0',
            },
        },
    },
    requiredApprovals: function (params) {
        var tokenIn = params.methodParams['params_tuple'].tokenIn;
        if (!tokenIn.value || typeof tokenIn.value !== 'string')
            return [];
        return [
            {
                to: tokenIn.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
